import React, { useCallback, useState } from 'react';
import axios from 'axios';
import { Label } from '../../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const QUERY_TARGET_ROLES = [
  { value: 'investigador_principal', es: 'Investigador Principal', en: 'Principal Investigator' },
  { value: 'investigador', es: 'Co-Investigador', en: 'Co-Investigator' },
  { value: 'director_estudio', es: 'Director Estudio', en: 'Study Director' },
  { value: 'reclutamiento', es: 'Reclutamiento', en: 'Recruitment' },
  { value: 'sondas', es: 'Sondas', en: 'Probes' },
];

// Usuarios del Personal del estudio por rol destino.
export const useQueryRecipients = (studyId) => {
  const [recipients, setRecipients] = useState({});
  const loadRecipients = useCallback(() => {
    axios.get(`${API_URL}/api/studies/${studyId}/queries/recipients`, { withCredentials: true })
      .then(r => setRecipients(r.data || {})).catch(() => setRecipients({}));
  }, [studyId]);
  return { recipients, loadRecipients };
};

// Desplegable «Usuario» (obligatorio) bajo el rol destino.
export const RecipientSelect = ({ role, recipients, value, onChange, lang, compact = false }) => {
  const es = lang === 'es';
  const list = (role && recipients[role]) || [];
  const empty = role && list.length === 0;
  return (
    <div className="space-y-1.5" data-testid="query-target-user-field">
      {!compact && <Label className="text-sm font-medium">{es ? 'Usuario' : 'User'} <span className="text-red-500">*</span></Label>}
      <Select value={value || undefined} onValueChange={onChange} disabled={!role || empty}>
        <SelectTrigger data-testid="query-target-user-select" className={`bg-white border-stone-200 ${compact ? 'h-8 text-xs' : ''}`}>
          <SelectValue placeholder={!role ? (es ? 'Elige antes el rol' : 'Choose the role first')
            : empty ? (es ? 'Nadie con ese rol en el Personal del estudio' : 'Nobody with that role in study staff')
              : (es ? 'Selecciona el usuario' : 'Select the user')} />
        </SelectTrigger>
        <SelectContent>
          {list.map(u => (
            <SelectItem key={u.id} value={u.id} data-testid={`query-target-user-option-${u.id}`} className={compact ? 'text-xs' : ''}>
              {u.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
